import Button from './Button';
import container from './Button.container';
export default container(Button);
//# sourceMappingURL=index.js.map